export default __webpack_public_path__ + "static/media/CMS_Info & updates.bc06a384.svg";